<template>
    <Layout>
        <PageHeader :title="title" :items="braedcrumb" />
        <b-overlay :show="show">
            <b-card>
                <b-table
                    :fields="fields"
                    bordered
                    head-row-variant="info"
                    small
                    :items="items"
                    sticky-header="65vh"
                >
                    <template #cell(provider_name)="{item}">
                        <a href="javascript:void(0)" @click="$router.push({ name : 'ProviderCard',query : { providerid : 0,providertin  : item.provider_tin} })">
                            {{ item.provider_name }}
                        </a>
                    </template>
                    <template #cell(buyer_name)="{item}">
                        <a href="javascript:void(0)" @click="$router.push({ name : 'BuyerCard',query : { buyerid : 0,buyertin  : item.buyer_tin} })">
                            {{ item.buyer_name }}
                        </a>
                    </template>
                </b-table>
            </b-card>
        </b-overlay>
    </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import ReportService from '@/services/reports/report.service'
export default {
    components : {Layout, PageHeader,},
    data(){
        return{
            braedcrumb: [
                {
                    text: this.$t("Document"),
                },
                {
                    text: this.$t("GetBuyersByProviderRisk"),
                    active: true,
                },
            ],
            title: this.$t("GetBuyersByProviderRisk"),
            show : false,
            fields : [
                {key : "buyer_name",label:this.$t('buyername'),class : 'text-left',thStyle : { verticalAlign : 'middle' }},
                // {key : "buyer_tin",label:this.$t('buyertin'),class : 'text-center',thStyle : { verticalAlign : 'middle' }},
                {key : "provider_name",label:this.$t('provider'),class : 'text-left',thStyle : { verticalAlign : 'middle' }},
                // {key : "provider_tin",label:this.$t('providertin'),class : 'text-center',thStyle : { verticalAlign : 'middle' }},
                {key : "lotcount",label:this.$t('lotcount'),class : 'text-center',thStyle : { verticalAlign : 'middle' },sortable:true}
            ],
            items : []
        }
    },
    created(){
        this.Refresh()
    },
    methods:{
        Refresh(){
            this.show = true
            ReportService.GetBuyersByProviderRisk().then(res => {
                this.show = false
                this.items = res.data.result
            }).catch(error => {
                this.$notification(error.response.data.error,'danger')
                this.show = false
            })
        }
    }
}
</script>

<style>

</style>